// extracted by mini-css-extract-plugin
export default {"challengeItem":"live-challenges-module--challengeItem--2JpIg"};